export const SERVER_AJAX_URL = 'https://commercial.cedarworks.com';
